"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { useParams, usePathname } from "next/navigation";
import { useEffect, useEffectEvent, useRef } from "react";
import { useIdle } from "@/hooks/use-idle";
import { useAuthStore } from "@/lib/stores/authStore";
import { SessionActivity, sessionActivityHandler } from "@/lib/utils/session-activity";

/**
 * Hook to track page navigation activity for authenticated users.
 * Records page transitions to the session activity service.
 */
export function usePageActivityTracking() {
  const $ = _c(10);
  const isIdle = useIdle(90000);
  const {
    workspaceId: t0
  } = useParams() as {
    workspaceId: string;
  };
  const workspaceId = t0 === undefined ? "" : t0;
  const pathname = usePathname();
  const previousPathnameRef = useRef(null);
  let t1;
  if ($[0] !== workspaceId) {
    t1 = (currentPath, previousPath) => {
      const isAuthenticated = useAuthStore.getState().isAuthenticated;
      if (!isAuthenticated) {
        return;
      }
      sessionActivityHandler.recordActivity({
        pageActivity: [{
          action: SessionActivity.pageActivityActions.PAGE_VIEW,
          payload: {
            currentPagePath: currentPath,
            previousPagePath: previousPath
          },
          time: new Date().toISOString()
        }],
        pagePath: currentPath,
        workspaceId
      });
    };
    $[0] = workspaceId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onPageChange = useEffectEvent(t1);
  let t2;
  if ($[2] !== onPageChange || $[3] !== pathname) {
    t2 = () => {
      const previousPathname = previousPathnameRef.current;
      if (previousPathname === null) {
        previousPathnameRef.current = pathname;
        return;
      }
      if (previousPathname === pathname) {
        return;
      }
      onPageChange(pathname, previousPathname);
      previousPathnameRef.current = pathname;
    };
    $[2] = onPageChange;
    $[3] = pathname;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== pathname) {
    t3 = [pathname];
    $[5] = pathname;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[7] !== isIdle) {
    t4 = () => {
      if (isIdle) {
        sessionActivityHandler.endSession();
      }
    };
    t5 = [isIdle];
    $[7] = isIdle;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
}